import { logger } from "../utils/utils";
import api from "./apis/api";

class BottlingService {
  createBottling(payload) {
    logger("BottlingService", "createBottling");
    return api.bottling.createBottling(payload);
  }

  updateBottling(payload) {
    logger("BottlingService", "updateBottling");
    return api.bottling.updateBottling(payload?.bottlingId, payload?.payload);
  }

  getBottlingList(payload) {
    logger("BottlingService", "getBottlingList");
    return api.bottling.getBottlingList(payload);
  }

  getBottlingSubList(payload) {
    logger("BottlingService", "getBottlingSubList");
    return api.bottling.getBottlingSubList(payload);
  }

  deleteBottleFromSubList(bottlingId) {
    logger("BottlingService", "deleteBottleFromSubList");
    return api.bottling.deleteBottleFromSubList(bottlingId);
  }
}

export default new BottlingService();
